import type { ChatAttachment } from './chat-input-attachment.interface'
import {
  isFileAttachment,
  isImageAttachment,
  MAX_IMAGE_ATTACHMENTS,
} from './chat-input-attachment.interface'

export interface PartitionedAttachments {
  fileList: ChatAttachment[]
  imageList: ChatAttachment[]
}

export const partitionAttachments = (
  attachmentList: ChatAttachment[],
  maxImageCount: number = MAX_IMAGE_ATTACHMENTS
): PartitionedAttachments => {
  const fileListResult: ChatAttachment[] = []
  const imageListResult: ChatAttachment[] = []

  for (const attachment of attachmentList) {
    if (isImageAttachment(attachment)) {
      imageListResult.push(attachment)
    }
    if (isFileAttachment(attachment)) {
      fileListResult.push(attachment)
    }
  }

  return {
    fileList: fileListResult,
    imageList: imageListResult.slice(0, maxImageCount),
  }
}
